export interface User {
    id: number;
    codigo: string;
    nome_completo: string;
    cpf: string;
    email: string;
    telefone?: string | null;
    celular?: string | null;
    data_nascimento?: string | null;
    cep?: string | null;
    logradouro?: string | null;
    numero?: string | null;
    bairro?: string | null;
    cidade?: string | null;
    estado?: string | null;
    _cTipoUser: string;
    ativo: string;
    _cSuperv?: string | null;
    gerente?: string | null;
    assessor?: string | null;
    regional?: string | null;
    filial?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    permite_cancelar: number;
    /** null = acesso total; [] = nenhuma; lista = só essas */
    permissions?: string[] | null;
    app_version?: string | null;
    one_signal_id?: string | null;
    ativa_senha_app: number;
    senha_app?: string | null;
}

export class UserModel {
    constructor(public data: User) {}

    isAdmin(): boolean {
        return this.data._cTipoUser === '1';
    }

    isActive(): boolean {
        return this.data.ativo === '1';
    }

    getName(): string {
        return this.data.nome_completo;
    }

    getEmail(): string {
        return this.data.email;
    }

    getCpf(): string {
        return this.data.cpf;
    }

    hasPermission(permissionName: string): boolean {
        const permissions = this.data.permissions;

        if (permissions == null) {
            return true;
        }

        if (!Array.isArray(permissions)) {
            return false;
        }

        if (permissions.includes('*')) {
            return true;
        }

        return permissions.includes(permissionName);
    }
}
